import React from "react";
import { XAxis, Text, usePlotArea } from "recharts";
import { CHART_TICK } from "./chartTheme";
import { dayTicks, formatDayTick } from "./chartFormat";

/**
 * The date axis of every daily super-admin chart. `dates` is the chart's dense
 * `["YYYY-MM-DD", ...]` axis, from the server.
 *
 * The labelled days are chosen here (`dayTicks`, from the plot width), not by Recharts:
 * `interval={0}` makes Recharts draw exactly these and never drop one after measuring its
 * text, so the same data labels the same days on every load, at an even spacing.
 *
 * A label is centred on its day, except at the ends of the axis: the last day's (today's,
 * always labelled) ends on its day and the first day's starts on it, so neither runs past
 * the plot, where the chart would clip it. Rendered inside a Recharts chart (it reads the
 * chart's plot area); extra props reach the `XAxis`.
 */
export default function DayXAxis({ dates, lang, ...axisProps }) {
  const plot = usePlotArea();
  const first = dates[0];
  const last = dates[dates.length - 1];
  const anchorFor = (date) => {
    if (date === last) return "end";
    return date === first ? "start" : "middle";
  };
  return (
    <XAxis
      dataKey="date" interval={0}
      ticks={dayTicks(dates, plot?.width)}
      tick={(props) => (
        <Text {...props} {...CHART_TICK} textAnchor={anchorFor(props.payload.value)}>
          {formatDayTick(props.payload.value, lang)}
        </Text>
      )}
      {...axisProps}
    />
  );
}
